// AssignmentRulesSheet.jsx — 한 배정의 급여 조건 기록 창 (2026-10-06)
//   배정 상세 [급여 조건] 과 1:1급여 정산 직원 상세 [급여 조건] 이 같이 쓴다. 속 내용은 기존 BillingRuleManager 그대로
//   (확정된 달에 쓰인 조건은 고치기 버튼이 없고, 새 조건 예약은 확정된 달 다음 날부터 — 서버가 막는 규칙 그대로).
import React from 'react';
import Modal from '../../../components/Modal';
import { stdOutlineBtn } from '../adminlayout/designStandard';
import { BillingRuleManager } from './BillingRuleManager';
import { fmtDate } from './assignmentStatus';
import { shortMd } from './assignmentText';
import { SH } from './assignmentSheet.styles';

export function AssignmentRulesSheet({ row, integratedMenuId = null, onChanged, onClose }) {
  if (!row) return null;
  const locked = fmtDate(row.condition_locked_through);
  const footer = (
    <div style={SH.footer}>
      <button type="button" style={stdOutlineBtn} onClick={onClose}>닫기</button>
    </div>
  );
  return (
    <Modal
      open
      title={`${row.consultant_name || '1:1 직원'} 급여 조건`}
      icon="🧾"
      onClose={onClose}
      footer={footer}
      width="min(820px, calc(100vw - 48px))"
      mobileSheet
      mobileSheetDragClose
    >
      <div style={SH.wrap}>
        <div style={SH.hint}>
          정한 날짜부터 새 조건이 적용되고, 그 전 기간은 이전 조건 그대로 계산합니다.
          {locked && <> {shortMd(locked)}까지는 1:1급여가 확정된 달이라 그 기간에 쓰인 조건은 잠겨 있어요(확정 취소하면 다시 고칠 수 있어요).</>}
        </div>
        <BillingRuleManager
          assignments={[row]}
          integratedMenuId={integratedMenuId}
          onChanged={onChanged}
          title="급여 조건 기록"
          sub="조건은 배정 기간 안에서만 쓰여요. 배정이 끝나면 조건도 마지막 근무일까지만 보여요."
        />
      </div>
    </Modal>
  );
}
